import { useCanGoBack, useRouter } from "@tanstack/react-router";
import { Button } from "~/components/ui/button";
import {
	Empty,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from "~/components/ui/empty";
import { LoadingIndicator } from "~/components/ui/loading-indicator";

export function PendingComponent() {
	const router = useRouter();
	const canGoBack = useCanGoBack();

	return (
		<div className="flex flex-1 items-center justify-center p-4">
			<Empty className="w-full">
				<EmptyHeader>
					<EmptyMedia variant="icon">
						<LoadingIndicator />
					</EmptyMedia>
					<EmptyTitle>Loading resource</EmptyTitle>
					<EmptyDescription>Please wait while we load the requested resource.</EmptyDescription>
				</EmptyHeader>
				<EmptyContent>
					{canGoBack ? (
						<Button variant="outline" size="sm" onClick={() => router.history.back()}>
							Back
						</Button>
					) : null}
				</EmptyContent>
			</Empty>
		</div>
	);
}
